import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleHamburgerMenu() {
    document.getElementById('hamburger-icon').classList.toggle("is-active");
    if(document.getElementById("mobile-menu").offsetWidth == 0) {
      document.getElementById("mobile-menu").style.width = "100%";
    } else {
      document.getElementById("mobile-menu").style.width = "0";
    }
  }
}